"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UnknownIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.352 11.065c0-1.004.126-1.803.377-2.398.252-.595.71-1.18 1.376-1.753.674-.58 1.121-1.05 1.343-1.409.222-.365.333-.749.333-1.15 0-1.212-.577-1.817-1.731-1.817-.548 0-.988.165-1.32.494-.326.323-.497.77-.511 1.344H3c.015-1.369.47-2.44 1.365-3.215C5.268.387 6.496 0 8.05 0c1.569 0 2.786.37 3.651 1.108.866.73 1.299 1.767 1.299 3.107 0 .61-.14 1.186-.422 1.731-.28.538-.773 1.136-1.476 1.796l-.899.828c-.562.523-.884 1.136-.965 1.839l-.045.655H6.352zm-.322 3.3c0-.48.166-.874.5-1.182.34-.316.773-.473 1.298-.473s.954.157 1.287.473c.34.308.511.702.511 1.183 0 .473-.167.863-.5 1.172-.325.308-.758.462-1.298.462s-.977-.154-1.31-.462c-.325-.309-.488-.7-.488-1.172z"
  })))
});
UnknownIcon.displayName = 'UnknownIcon';
var _default = exports.default = UnknownIcon;